import PriceContent from "../content/priceContent";
import Layout from "../layout/Layout";

const Vehicles = () => {
  return (
    <Layout>
      <PriceContent />
    </Layout>
  );
};

export default Vehicles;
